// extracted by mini-css-extract-plugin
export default {"NewUserForm":"styles_NewUserForm__fEScq","leftCol":"styles_leftCol__Xg9cG","rightCol":"styles_rightCol__WvVqb","footer":"styles_footer__IDShi"};